module.exports = __webpack_public_path__ + "static/en-section-4@2x-27e13210d6e7cf691fef584bc56b6659.png";